<template>
	<div>
		<div style="font-weight: 700">
			{{ section === 'education' ? row.organization : row.job_title }}
		</div>
		<div>
			{{ section === 'education' ? row.education : row.organization }}
		</div>
		<div style="font-size: 0.75rem" v-if="row.start_date || row.end_date">
			<span>{{ formatMonth(row.start_date) }}</span>
			<span> - </span>
			<span v-if="section === 'work_experience' && row.is_current">{{
				$t('label.present')
			}}</span>
			<span v-else>{{ formatMonth(row.end_date) }}</span>
		</div>
		<div
			style="font-size: 0.85rem"
			v-if="section === 'work_experience' && row.job_description"
		>
			{{ row.job_description }}
		</div>
	</div>
</template>

<script>
import { format } from 'date-fns';

export default {
	name: 'ProfileEditHistoryRow',
	props: {
		row: {
			type: Object,
			required: true,
		},
		section: {
			type: String,
			required: true,
		},
	},
	methods: {
		formatMonth(timestamp) {
			if (!timestamp) {
				return '';
			}
			try {
				return format(new Date(timestamp), 'MMM yyyy');
			} catch (error) {
				return '';
			}
		},
	},
};
</script>
